/* eslint-disable no-nested-ternary */
import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, EditAmountDialogueHandler } from '../types';
import EditAmountDialogueContext from './EditAmountContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue, TextField } = vp;

type EditAmountDialogueProps = {
  setEditAmount: (e: string) => void;
  handleDialogue: DialogueHandler<EditAmountDialogueHandler>;
  initalAmount: string;
};

type FC = FunctionComponent<EditAmountDialogueProps>;

const EditAmountDialogue: FC = ({ setEditAmount, handleDialogue, initalAmount }: EditAmountDialogueProps) => {
  const { shouldOpenEditAmountModal, showEditAmountErrorAlert, sendEditAmountError } =
    useContext(EditAmountDialogueContext);
  const { t } = useTranslation('translations', { keyPrefix: 'ScheduledTransactions.Details.History.Dialogues' });

  return useMemo(
    () => (
      <div>
        {/* Amount Edit */}
        <ConfirmationDialogue
          isVisible={shouldOpenEditAmountModal}
          title={t('AmountEdit.title')}
          status="none"
          subTitle={
            <TextField
              name="edit-amount"
              width="100%"
              preset="number"
              onBlur={() => {}}
              value={initalAmount}
              onChange={(e) => {
                setEditAmount(e.target.value);
              }}
              error={getErrorMessage(initalAmount)}
            />
          }
          confirm={{
            label: t('AmountEdit.saveButton'),
            action: () => handleDialogue({ type: 'confirm', state: 'success' }),
          }}
          cancel={{
            label: t('AmountEdit.cancelButton'),
            action: () => handleDialogue({ type: 'confirm', state: 'fail' }),
          }}
        />
        {/* Amount Edit Error */}
        <ConfirmationDialogue
          isVisible={showEditAmountErrorAlert}
          title={t('AmountEditError.title')}
          status="error"
          subTitle={`${sendEditAmountError}`}
          confirm={{
            label: t('AmountEditError.backButton'),
            action: () => handleDialogue({ type: 'error', state: 'fail' }),
          }}
        />
      </div>
    ),
    [shouldOpenEditAmountModal, showEditAmountErrorAlert, sendEditAmountError, initalAmount],
  );

  function getErrorMessage(value: string) {
    if (value === '') {
      return t('AmountEdit.requiredErrorMessage');
    }
    if (Number(value) === 0) {
      return t('AmountEdit.shouldBeGreaterThanZeroErrorMessage');
    }
    return null;
  }
};

export default EditAmountDialogue;
